import axios from 'axios';

export default {
    methods: {
        async notifUsuarioSinLeer(ok, err) {
            try {
                let r = await axios.post('notif/usuario-sin-leer');
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async notifUsuario(ok, err) {
            try {
                let r = await axios.post('notif/usuario');
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async notifLeida(d,ok, err) {
            try {
                let r = await axios.post('notif/leida',d);
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/notificaciones.js